import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

function OpenMenu() {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);
    const [pendingCount, setPendingCount] = useState();

    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location.pathname]);

    const handleClearSession = () => {
        toast.info('Logout Successfully', { position: "top-right", autoClose: 1000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", });
        sessionStorage.clear();
    };

    useEffect(() => {
        const fetchOrderCounts = async () => {
            try {
                const pendingResponse = await fetch('https://backend.bkabab.com/orders/count/pending');
                const pendingData = await pendingResponse.json();
                setPendingCount(pendingData.pending);
            } catch (error) {
                console.error('Error fetching order counts:', error);
            }
        };
        // Initial fetch
        fetchOrderCounts();
        const intervalId = setInterval(() => {
            fetchOrderCounts();
        }, 500);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className='main-open-side-bar'>
            <div>
                <div className={`leftasidemenu-open ${activeLink === '/dashboard' ? 'active' : ''}`}>
                    <Link id='links' to='/dashboard'>
                        <div id='menuasidemain'>
                            <i className="las la-tachometer-alt"></i>
                            <div id='asidemain1'>
                                <p>Dashboard</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/orders' ? 'active' : ''}`}>
                    <Link id='links' to='/orders'>
                        <div id='menuasidemain'>
                            <i className="las la-luggage-cart"></i>
                            <div id='asidemain1'>
                                <p>Orders</p>
                                {pendingCount > 0 && <p className='count-order-show'>{pendingCount}</p>}
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/history' ? 'active' : ''}`}>
                    <Link id='links' to='/history'>
                        <div id='menuasidemain'>
                            <i className="las la-history"></i>
                            <div id='asidemain1'>
                                <p>Order History</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/alldishes' ? 'active' : ''}`}>
                    <Link id='links' to='/alldishes'>
                        <div id='menuasidemain'>
                            <i className="las la-stream"></i>
                            <div id='asidemain1'>
                                <p>Dishes</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/adddishes' ? 'active' : ''}`}>
                    <Link id='links' to='/adddishes'>
                        <div id='menuasidemain'>
                            <i className="las la-cart-plus"></i>
                            <div id='asidemain1'>
                                <p>Add Dish</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/userinfo' ? 'active' : ''}`}>
                    <Link id='links' to='/userinfo'>
                        <div id='menuasidemain'>
                            <i className="las la-users"></i>
                            <div id='asidemain1'>
                                <p>Users Info</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/adduser' ? 'active' : ''}`}>
                    <Link id='links' to='/adduser'>
                        <div id='menuasidemain'>
                            <i className="las la-user-tie"></i>
                            <div id='asidemain1'>
                                <p>New User</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/admininfo' ? 'active' : ''}`}>
                    <Link id='links' to='/admininfo'>
                        <div id='menuasidemain'>
                            <i className="las la-user-lock"></i>
                            <div id='asidemain1'>
                                <p>Admins Info</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={`leftasidemenu-open ${activeLink === '/addadmin' ? 'active' : ''}`}>
                    <Link id='links' to='/addadmin'>
                        <div id='menuasidemain'>
                            <i className="las la-user-plus"></i>
                            <div id='asidemain1'>
                                <p>New Admin</p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div>
                <div className='leftasidemenu-open'>
                    <Link id='links' to='/' onClick={handleClearSession}>
                        <div id='menuasidemain'>
                            <i className="las la-sign-out-alt"></i>
                            <div id='asidemain1'>
                                <p>Log Out</p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default OpenMenu;
